import React from "react";
import { Link } from "react-router-dom";
import { registeredGames } from "../games/gameRegistry";
import { buildGamePath } from "../games/gamePaths";
import "./GameLandingPage.css";

function getLandingDetails(game, index) {
  return {
    accentColor: "#2b7fa7",
    penguinImage: `/penguins/${(index % 6) + 1}.png`,
    penguinPose: index % 2 === 0 ? "penguin-left" : "penguin-right",
    ...game.landing,
  };
}

export function GameLandingPage() {
  const publicPath = process.env.PUBLIC_URL || "";

  return (
    <main
      className="landing-page"
      aria-labelledby="landing-title"
      style={{ backgroundImage: `url(${publicPath}/background.png)` }}
    >
      <span className="snow-flurry snow-flurry-back" aria-hidden="true" />
      <span className="snow-flurry snow-flurry-front" aria-hidden="true" />

      <h1 className="sr-only" id="landing-title">
        Pick your adventure
      </h1>

      <section className="landing-content">
        <div className="game-picker" aria-label="Choose a game">
          {registeredGames.map((game, index) => {
            const landingDetails = getLandingDetails(game, index);

            return (
              <Link
                className="game-choice"
                key={game.slug}
                style={{ "--choice-accent": landingDetails.accentColor }}
                to={buildGamePath(game.slug)}
              >
                <span className="game-choice-title">Play {game.name}</span>
                <span
                  className={`penguin-stage ${landingDetails.penguinPose}`}
                  aria-hidden="true"
                >
                  <span className="penguin-shadow" />
                  <img
                    alt=""
                    className="penguin-mascot"
                    src={`${publicPath}${landingDetails.penguinImage}`}
                  />
                </span>
              </Link>
            );
          })}
        </div>
      </section>
    </main>
  );
}
